import { GET } from './Clients';

const getConfigWms = () =>
  GET({
    url: '/warehouse/core/v1/config?warehouseCode=CAM',
    isBasic: true,
    cache: true,
    cacheServer: false,
    cacheTime: 10,
  });

export default {
  getConfigWms,
};
